var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-tile-layer',{key:_vm.templateName,ref:"sceneLayer",attrs:{"tile-layer-class":_vm.tileLayer}})}
var staticRenderFns = []

export { render, staticRenderFns }